import { Box, Container, Image } from '@chakra-ui/react';
import { ReactElement } from 'react';
import { routes } from '../../../../constants/routes';
import { CDN_LOGO_URL, commonConfig } from '../../config';
import ErrorInfo, { ErrorProps } from './Info/ErrorInfo';

/**
 * Error component
 */
const Error = (props: ErrorProps): ReactElement | null => (
  <Box position="relative" w="full" h="100%" bgSize="cover" bgRepeat="no-repeat" data-id="Error">
    <Box position="absolute" left={0} top={0}>
      <a href={routes.HOME}>
        <Image
          src={`${CDN_LOGO_URL}/rumi-logo.svg`}
          _dark={{ display: 'none' }}
          alt={commonConfig.company.name}
          htmlWidth="844"
          htmlHeight="238"
          w={{ base: '175px', sm: '200px' }}
          h="auto"
          p={4}
        />
        <Image
          src={`${CDN_LOGO_URL}/rumi-logo-white.svg`}
          display={'none'}
          _dark={{ display: 'inline-flex' }}
          alt={commonConfig.company.name}
          htmlWidth="844"
          htmlHeight="238"
          w={{ base: '175px', sm: '200px' }}
          h="auto"
          p={4}
        />
      </a>
    </Box>
    <Container
      maxW="container.lg"
      h="full"
      flexDirection="row"
      justifyContent="center"
      centerContent
      py={20}
    >
      <ErrorInfo {...props} />
    </Container>
  </Box>
);

export default Error;
